/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Components
import Header from '../components/header.js';
import WhyCyperhost from '../components/sections/whyCyperhost';
import Modpacks from '../components/sections/modpacks';
import Panel from '../components/sections/panelMockup';
import DDoSProtection from '../components/sections/ddosProtection';
import Location from '../components/sections/location';
import Reviews from '../components/sections/reviews';
import Button from '../components/buttons/primary.js';
import Footer from '../components/footer.js';
// React Router
import { Link } from 'react-router-dom';
// Images
import hero from '../assets/images/homehero.webp';
import looking from '../assets/images/illustrations/looking.svg';

const Home = () => {
    return (
        <main>
            <div className="home-hero">
                <Header />
                <div className="content max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 pt-20 sm:pt-20 md:pt-20 lg:pt-40">
                    <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2'>
                        <div>
                            <h1 className='text-gray-200 font-semibold text-5xl leading-snug mb-7'>Revolutionary Minecraft Server Hosting</h1>
                            <p className='text-gray-300 text-lg mb-9'>Stop lacking features, and use Cyperhost.</p>
                            <ul className='mb-12'>
                                <li className='flex items-center text-gray-300 text-xl mb-3.5'>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-3 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    Reliable Network
                                </li>
                                <li className='flex items-center text-gray-300 text-xl mb-3.5'>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-3 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    AMD Ryzen CPU's
                                </li>
                                <li className='flex items-center text-gray-300 text-xl mb-3.5'>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-3 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    Friendly Support
                                </li>
                                <li className='flex items-center text-gray-300 text-xl mb-3.5'>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-3 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    Custom Control Panel
                                </li>
                                <li className='flex items-center text-gray-300 text-xl'>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-3 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    Plans starting $4/mo
                                </li>
                            </ul>
                            <Link to="/games/minecraft" className="bg-primary hover:bg-secondary px-9 py-3.5 text-gray-100 hover:text-white rounded-md transition">Get Started</Link>
                        </div>
                        <div className='hidden sm:hidden md:block lg:block'>
                            <img src={hero} alt="Hero Image" className='block ml-auto' />
                        </div>
                    </div>
                </div>
            </div>
            <WhyCyperhost />
            <Modpacks />
            <div className='plans max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-28'>
                <div className="header mb-24">
                    <h1 className="text-gray-100 text-center text-3xl font-semibold mb-4">Featured Minecraft Hosting Plans</h1>
                    <p className="text-gray-300 text-center">Here is some of our most popular Minecraft Server Plans</p>
                </div>
                <div className='body'>
                    <div className="popular-plans bg-primaryDark rounded-lg px-1.5 mb-6">
                        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-4 py-8">
                            <div className="hosting-plan px-9 py-6">
                                <div className="plan-info mb-8">
                                    <h1 className="text-gray-300 font-semibold text-xl text-center mb-5">Budget Plan</h1>
                                    <p className="text-gray-100 font-bold text-2xl text-center">4GB</p>
                                </div>
                                <div className="plan-specs mb-9">
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">CPU</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">Intel Xeon E5 1650v4</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Storage</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">50GB NVMe</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Free Subdomain</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">DDoS Protection</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Plugin Installer</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='plan-price mb-9'>
                                    <h1 className='text-gray-200 font-semibold text-3xl text-center'>$4 <br /><span className='text-xl'>/month</span></h1>
                                </div>
                                <div className="plan-order flex justify-center">
                                    <Button link="https://client.cyperhost.com/cart.php?a=add&pid=95&configoption[117]=450" title="Choose Plan" />
                                </div>
                            </div>
                            <div className="hosting-plan px-9 py-6">
                                <div className="plan-info mb-8">
                                    <h1 className="text-gray-300 font-semibold text-xl text-center mb-5">Budget Plan</h1>
                                    <p className="text-gray-100 font-bold text-2xl text-center">6GB</p>
                                </div>
                                <div className="plan-specs mb-9">
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">CPU</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">Intel Xeon E5 1650v4</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Storage</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">50GB NVMe</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Free Subdomain</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">DDoS Protection</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Plugin Installer</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='plan-price mb-9'>
                                    <h1 className='text-gray-200 font-semibold text-3xl text-center'>$6 <br /><span className='text-xl'>/month</span></h1>
                                </div>
                                <div className="plan-order flex justify-center">
                                    <Button link="https://client.cyperhost.com/cart.php?a=add&pid=95&configoption[117]=451" title="Choose Plan" />
                                </div>
                            </div>
                            <div className="hosting-plan px-9 py-6">
                                <div className="plan-info mb-8">
                                    <h1 className="text-gray-300 font-semibold text-xl text-center mb-5">Premium Plan</h1>
                                    <p className="text-gray-100 font-bold text-2xl text-center">8GB</p>
                                </div>
                                <div className="plan-specs mb-9">
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">CPU</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">AMD Ryzen 7 5800x</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Storage</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">50GB NVMe</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Free Subdomain</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">DDoS Protection</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Plugin Installer</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='plan-price mb-9'>
                                    <h1 className='text-gray-200 font-semibold text-3xl text-center'>$14 <br /><span className='text-xl'>/month</span></h1>
                                </div>
                                <div className="plan-order flex justify-center">
                                    <Button link="https://client.cyperhost.com/cart.php?a=add&pid=2&configoption[31]=64" title="Choose Plan" />
                                </div>
                            </div>
                            <div className="hosting-plan no-border px-9 py-6">
                                <div className="plan-info mb-8">
                                    <h1 className="text-gray-300 font-semibold text-xl text-center mb-5">Premium Plan</h1>
                                    <p className="text-gray-100 font-bold text-2xl text-center">10GB</p>
                                </div>
                                <div className="plan-specs mb-9">
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">CPU</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">AMD Ryzen 7 5800x</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Storage</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">50GB NVMe</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Free Subdomain</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">DDoS Protection</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Plugin Installer</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='plan-price mb-9'>
                                    <h1 className='text-gray-200 font-semibold text-3xl text-center'>$17.50 <br /><span className='text-xl'>/month</span></h1>
                                </div>
                                <div className="plan-order flex justify-center">
                                    <Button link="https://client.cyperhost.com/cart.php?a=add&pid=2&configoption[31]=82" title="Choose Plan" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="more-plans bg-primaryDark rounded-lg py-7 sm:py-7 md:py-7 lg:py-0 px-10">
                        <div className="flex flex-wrap items-center">
                            <div className="flex items-center mb-8 sm:mb-8 md:mb-0 lg:mb-0">
                                <img src={looking} alt="Customize Plan" className="hidden sm:hidden md:hidden lg:block pt-2" />
                                <div className="ml-0 sm:ml-0 md:ml-0 lg:ml-20">
                                    <h1 className="text-gray-100 text-2xl font-semibold mb-1">Looking for more Power?</h1>
                                    <p className="text-gray-300">Browse our other plans or customize your own solution!</p>
                                </div>
                            </div>
                            <div className="flex items-center ml-0 sm:ml-0 md:ml-auto lg:ml-auto">
                                <div>
                                    <a href="https://client.cyperhost.com/store/game-servers/minecraft-server" className="bg-transparent border border-gray-100 px-7 py-2.5 text-gray-100 rounded-md text-sm">Customize</a>
                                </div>
                                <div className="ml-3">
                                    <Link to="/games/minecraft" className="bg-gray-100 border border-gray-100 px-7 py-2.5 text-gray-900 font-semibold rounded-md text-sm flex items-center">Browse <span className="hidden sm:hidden md:block lg:block ml-0.5">More!</span></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Panel />
            <DDoSProtection />
            <Location />
            <Reviews />
            <Footer />
        </main>
    )
}

export default Home